import React from 'react'
import BackToUp from '@uiw/react-back-to-top';
import Ban from '../components/Desktop3/ban/Ban'
import WordsAboutUs from '../components/Desktop3/words_about_us/WordsAboutUs'
// import WhatDifferent from '../components/Desktop3/what_different/WhatDifferent'
import Testimonial from '../components/organic1/testimonial/Testimonial';
import LatestBlog from '../components/organic1/latest_blog/LatestBlog';
const Desktop3 = () => {
  return (
    <>
    <Ban/>
    <WordsAboutUs/>
    {/* <WhatDifferent/> */}
    <Testimonial/>
    <LatestBlog/>
    <div className="container">
      <BackToUp><i class="fa-solid fa-arrow-up"></i></BackToUp>
    </div>
    </>
  )
}

export default Desktop3